<template>
  <div>
    <div class="ticketing-steps bg-white border-bottom">
      <div class="container">
        <div class="row">
          <div class="col ticketing-step">
            <div :class="{ 'text-danger': step === 1 }">
              <i class="fe fe-grid"></i>
              <span>{{ this.$root.translate('ticketing.voucher.step_quantity') }}</span>
            </div>
          </div>
          <div class="col ticketing-step">
            <div :class="{ 'text-danger': step === 2 }">
              <i class="fe fe-credit-card"></i>
              <span>{{ this.$root.translate('ticketing.voucher.step_payment') }}</span>
            </div>
          </div>
          <div class="col ticketing-step">
            <div :class="{ 'text-danger': step === 3 }">
              <i class="fe fe-inbox"></i>
              <span>{{ this.$root.translate('ticketing.voucher.step_success') }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container">
      <div class="header mb-3"></div>

      <div class="row">
        <div class="col-lg-4 col-12 order-sm-last">

          <div class="card card-sm" v-if="step === 1">
            <div class="card-body">
              <div class="row">
                <div class="col" v-if="data.products.length > 0">
                  <p>
                    Moveek vẫn chưa chính thức bán vé Lotte Cinema. Mời bạn mua voucher vé Lotte nhé.
                  </p>
                  <p>
                    <strong class="text-danger">{{ new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(data.products[0].price) }} cho mọi loại ghế 2D</strong> (bao gồm ghế VIP) trong
                    tất cả các ngày (bao gồm cuối tuần, lễ, Tết).
                  </p>
                  <p class="mb-0 text-center">
                    <a href="#" class="text-danger" data-toggle="modal" data-target="#voucherPolicyModal">Điều kiện sử dụng</a>
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div class="card d-none d-md-block">
            <div class="card-body">
              <div class="row align-items-center">
                <div class="col">
                  <h6 class="card-title text-uppercase text-muted mb-2">
                    {{ $root.translate('ticketing.order_total') }}
                  </h6>
                  <span class="h2 mb-0">
                    {{ new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(order.total) }}
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div class="card card-sm" v-if="step === 2">
            <div class="card-body">
              <div class="row">
                <div class="col">
                  <p class="mb-0">
                    Voucher đã mua không thể đổi hoặc hoàn tiền. Voucher sẽ được gửi 01 lần qua số điện thoại
                    và email đã nhập. Vui lòng kiểm tra lại thông tin trước khi tiếp tục.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div class="flow-actions sticky-footer-bars">
            <div class="row">
              <div class="col-3">
                <a href="#" class="btn btn-lg btn-outline-dark btn-block" :class="{ 'disabled' : step === 1 }" v-on:click="stepHandler('prev', $event)">
                  &larr;
                </a>
              </div>
              <div class="col-9">
                <a href="#" class="btn btn-lg btn-dark btn-block" :class="{ 'disabled': this.cart.products.length === 0 }" v-on:click="stepHandler('next', $event)">
                  <span class="d-md-none">{{ new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(order.total) }} |</span>
                  {{ step === 2 ? $root.translate('ticketing.choose_payment') : $root.translate('ticketing.continue') }}
                </a>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-8 col-12">
          <div class="alert alert-danger" v-if="errors.length > 0">
            <p><strong>Có lỗi xảy ra:</strong></p>
            <ul>
              <li v-for="error in errors">{{ error }}</li>
            </ul>
            <p class="mb-0">
              Vui lòng thử lại hoặc <a href="/support" class="text-white">liên hệ trung tâm hỗ trợ</a>.
            </p>
          </div>

          <div v-if="errors.length === 0">
            <div id="ticketing-step-1" v-if="step === 1">
              <div class="ticketing-content">
                <div class="card">
                  <div class="table-responsive">
                    <table class="table table-nowrap card-table">
                      <thead>
                        <tr>
                          <th>Loại</th>
                          <th class="text-right d-none d-sm-block">Giá tiền</th>
                          <th class="text-center">Số lượng</th>
                        </tr>
                      </thead>
                      <tbody v-if="data.products.length > 0">
                        <tr v-for="product in data.products">
                          <td>
                            {{ product.name }}
                            <span class="d-block text-muted">
                              Ngày hết hạn: {{ new Date(product.expiredDate).toLocaleString('vi-VN', { day: '2-digit', month: '2-digit', year: 'numeric' }) }}
                            </span>
                            <span class="d-block d-sm-none text-muted">
                              {{ new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(product.price) }}
                            </span>
                          </td>
                          <td class="text-right d-none d-sm-block">
                            {{ new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(product.price) }}
                          </td>
                          <td class="text-center">
                            <div class="quantity-toggle">
                              <a class="btn btn-sm btn-rounded-circle btn-white" :class="{ 'disabled': product.quantity === 0 }" v-on:click="productPicker(product, 'remove')">-</a>
                              <input type="text" min="0" max="10" class="form-control form-control-flush text-dark text-center d-inline" :value="product.quantity" style="width: 30px;" readonly>
                              <a class="btn btn-sm btn-rounded-circle btn-white" :class="{ 'disabled': product.quantity === 10 }" v-on:click="productPicker(product, 'add')">+</a>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                      <tbody v-else>
                        <tr>
                          <td colspan="3">
                            Không có sản phẩm nào đang khả dụng.
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <div id="ticketing-step-2" v-if="step === 2">
              <div class="ticketing-content">
                <div class="card">
                  <div class="card-header bg-light">
                    <div class="card-header-title text-muted">
                      {{ $root.translate('ticketing.order_summary') }}
                    </div>
                  </div>
                  <div class="table-responsive">
                    <table class="table card-table">
                      <thead>
                        <tr>
                          <th>Mô tả</th>
                          <th class="text-center">Số lượng</th>
                          <th class="text-right">Thành tiền</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="product in cart.products">
                          <td>{{ product.name }}</td>
                          <td class="text-center">{{ product.quantity }}</td>
                          <td class="text-right">{{ new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(product.price * product.quantity) }}</td>
                        </tr>
                        <tr>
                          <td colspan="2">Phí tiện ích</td>
                          <td class="text-right">0 ₫</td>
                        </tr>
                        <tr>
                          <td colspan="2">Tổng</td>
                          <td class="text-right">{{ new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(order.total) }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div class="card">
                  <div class="card-header bg-light">
                    <div class="card-header-title text-muted">
                      {{ $root.translate('ticketing.personal_information') }}
                    </div>
                  </div>
                  <div class="card-body">
                    <div class="row">
                      <div class="col-sm-4 col-12">
                        <div class="form-group">
                          <label for="ticketing_voucher_contact_fullname" class="required">
                            Họ và tên
                            <span class="invalid-feedback" :class="{ 'd-block' : this.cart.checkout === true && this.cart.contact.fullname === '' }">
                          <span class="d-block">
                            <span class="form-error-icon badge badge-danger text-uppercase">Lỗi</span>
                            <span class="form-error-message">Giá trị không được phép để trống.</span>
                          </span>
                        </span>
                          </label>
                          <input type="text" id="ticketing_voucher_contact_fullname" required="required" class="form-control" :class="{ 'is-invalid' : this.cart.checkout === true && this.cart.contact.fullname === '' }" v-model="cart.contact.fullname">
                        </div>
                      </div>
                      <div class="col-sm-4 col-12">
                        <div class="form-group">
                          <label for="ticketing_voucher_contact_phone" class="required">
                            Số điện thoại
                            <span class="invalid-feedback" :class="{ 'd-block' : this.cart.checkout === true && this.cart.contact.phone === '' }">
                          <span class="d-block">
                            <span class="form-error-icon badge badge-danger text-uppercase">Lỗi</span>
                            <span class="form-error-message">Giá trị không được phép để trống.</span>
                          </span>
                        </span>
                          </label>
                          <input type="tel" id="ticketing_voucher_contact_phone" required="required" class="form-control" :class="{ 'is-invalid' : this.cart.checkout === true && this.cart.contact.phone === '' }" v-model="cart.contact.phone">
                        </div>
                      </div>
                      <div class="col-sm-4 col-12">
                        <div class="form-group">
                          <label for="ticketing_voucher_contact_email">
                            Email
                          </label>
                          <input type="email" id="ticketing_voucher_contact_email" class="form-control" v-model="cart.contact.email">
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="card">
                  <div class="card-header bg-light">
                    <div class="card-header-title text-muted">
                      {{ $root.translate('ticketing.payment_method') }}
                    </div>
                  </div>
                  <div class="card-body">

                    <div class="payment-gateway clearfix" :class="{ 'active' : this.cart.paymentGateway === 'moveek' && this.cart.paymentMethod === 'BANK_TRANSFER' }" v-on:click="paymentMethodPicker('moveek', 'BANK_TRANSFER')">
                      <i class="fe fe-check-circle pg-checked"></i>
                      <div class="pg-info">
                        <img :src="$root.asset('bundles/ornweb/img/moveek-icon.png')" alt="">
                        Chuyển khoản / Quét mã QR
                        <span class="pm-description">
                          Tự động xuất mã voucher trong 30s sau khi chuyển khoản
                        </span>
                      </div>
                    </div>

                    <div class="payment-gateway clearfix" :class="{ 'active' : this.cart.paymentGateway === 'momo' }" v-on:click="paymentMethodPicker('momo')">
                      <i class="fe fe-check-circle pg-checked"></i>
                      <div class="pg-info">
                        <img :src="$root.asset('bundles/ornweb/img/momo-icon.png')" alt="">
                        Ví MoMo
                      </div>
                    </div>

                    <div class="payment-gateway clearfix" :class="{ 'active' : this.cart.paymentGateway === 'payoo' && this.cart.paymentMethod === 'cc' }" v-on:click="paymentMethodPicker('payoo', 'cc')">
                      <i class="fe fe-check-circle pg-checked"></i>
                      <div class="pg-info">
                        <img :src="$root.asset('bundles/ornweb/img/payoo-icon.png')" alt="">
                        Thẻ ATM / Thẻ quốc tế
                      </div>
                    </div>

                    <div v-if="this.data.user.id !== null" class="payment-gateway clearfix" :class="{ 'active' : this.cart.paymentGateway === 'moveek' && this.cart.paymentMethod === 'MOVEEK_CREDITS', 'disabled' : this.cart.creditPayable === false }" v-on:click="paymentMethodPicker('moveek', 'MOVEEK_CREDITS')">
                      <i class="fe fe-check-circle pg-checked"></i>
                      <div class="pg-info">
                        <img :src="$root.asset('bundles/ornweb/img/moveek-icon.png')" alt="">
                        Moveek Credits
                        <span class="pm-description">
                          {{ $root.translate('ticketing.moveek_credits_balance') }}:
                          <strong class="text-dark">
                            {{ new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(data.user.balance) }}
                          </strong>
                        </span>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="voucherPolicyModal" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="card mb-0">
            <div class="card-header">
              <div class="row align-items-center">
                <div class="col">
                  <h4 class="card-header-title">
                    Điều kiện sử dụng voucher vé xem phim
                  </h4>
                </div>
                <div class="col-auto">
                  <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
              </div>
            </div>
            <div class="card-body">
              <p>1. Vé áp dụng cho tất cả suất chiếu phim 2D vào tất cả các ngày trong tuần (bao gồm Lễ, Tết) tại hệ thống
                rạp Lotte Cinema trên toàn quốc. Ngoại trừ các suất chiếu đặc biệt theo quy định của nhà sản xuất hoặc nhà
                phát hành phim công bố tại từng thời điểm.</p>
              <p>2. Không áp dụng cho phim 3D và các phòng chiếu đặc biệt khác như Superplex, Cinecomfort, Charlotte...</p>
              <p>3. Khách hàng sẽ nhận được 01 mã đổi vé xem phim điện tử trên toàn hệ thống Lotte Cinema.</p>
              <p>4. Mỗi Mã phiếu đổi vé xem phim điện tử có thể quy đổi thành 01 vé xem phim 2D - cho loại ghế Thường hoặc VIP tại quầy vé.</p>
              <p>5. Một khách hàng được mua nhiều voucher</p>
              <p>6. E-Voucher/E-Coupon không có giá trị quy đổi thành tiền mặt, không trả lại tiền thừa, không được hoàn hủy.</p>
              <p>7. Không áp dụng đồng thời với chương trình khuyến mại khác.</p>
              <p>8. Vé được cung cấp dưới dạng mã code.</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="orderConfirmModal" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="card mb-0">
            <div class="card-header">
              <div class="row align-items-center">
                <div class="col">
                  <h4 class="card-header-title">
                    Xác nhận đơn hàng
                  </h4>
                </div>
                <div class="col-auto">
                  <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
              </div>
            </div>
            <div class="card-body" v-if="this.cart.products.length > 0">
              <ul class="list-group list-group-flush list mb-3">
                <li class="list-group-item px-0">
                  <div class="row align-items-center">
                    <div class="col-4 col-sm-3">Rạp</div>
                    <div class="col">Lotte Cinema</div>
                  </div> <!-- / .row -->
                </li>
                <li class="list-group-item px-0">
                  <div class="row align-items-center">
                    <div class="col-4 col-sm-3">Phim</div>
                    <div class="col">Các phim đang chiếu</div>
                  </div> <!-- / .row -->
                </li>
                <li class="list-group-item px-0">
                  <div class="row align-items-center">
                    <div class="col-4 col-sm-3">Suất</div>
                    <div class="col">Các suất 2D (bao gồm cuối tuần, lễ, Tết)</div>
                  </div> <!-- / .row -->
                </li>
                <li class="list-group-item px-0">
                  <div class="row align-items-center">
                    <div class="col-4 col-sm-3">Ghế</div>
                    <div class="col">Ghế 2D (bao gồm cả ghế VIP)</div>
                  </div> <!-- / .row -->
                </li>
                <li class="list-group-item px-0">
                  <div class="row align-items-center">
                    <div class="col-4 col-sm-3">Ngày hết hạn</div>
                    <div class="col">{{ new Date(this.cart.products[0]?.expiredDate).toLocaleString('vi-VN', { day: '2-digit', month: '2-digit', year: 'numeric' }) }}</div>
                  </div> <!-- / .row -->
                </li>
                <li class="list-group-item px-0">
                  <div class="row align-items-center">
                    <div class="col-4 col-sm-3">Thông tin<br />cá nhân</div>
                    <div class="col">
                      {{ this.cart.contact?.fullname }}
                      <br />{{ this.cart.contact?.email }}
                      <br />{{ this.cart.contact?.phone }}
                    </div>
                  </div> <!-- / .row -->
                </li>
              </ul>
              <a href="#" class="btn btn-danger btn-block" :class="{ 'disabled': order.status !== 'pending' }" v-on:click="createOrder()">
                <span v-if="order.status === 'processing'" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                <span v-if="order.status === 'pending'">{{ $root.translate('ticketing.choose_proceed_checkout') }}</span>
                <span v-if="order.status === 'awaiting_payment'">{{ $root.translate('ticketing.redirect_payment_gateway_short') }}</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import axios from 'axios';
import { bindStickyBar } from '../dependencies/sticky-bar';
import { initAmplitude, trackVoucherEvent } from '../dependencies/amplitude';
import BootstrapNative from 'bootstrap.native/dist/bootstrap-native-v4';

export default {
  name: 'Voucher',
  props: [
    'cineplex',
    'user'
  ],
  created() {
    this.getProduct()
    this.getContact()
    this.getUser()
  },
  mounted() {
    initAmplitude()
    trackVoucherEvent('Voucher Flow Initiated', this.data.cineplex)
    setTimeout(function () {
      bindStickyBar()
    }, 500)
  },
  data() {
    return {
      step: 1,
      data: {
        cineplex: {
          id: 18785,
          name: 'Lotte Cinema'
        },
        products: [],
        user: {
          id: null,
          balance: 0
        },
      },
      cart: {
        products: [],
        paymentGateway: 'moveek',
        paymentMethod: 'BANK_TRANSFER',
        creditPayable: false,
        checkout: false,
        contact: {},
      },
      order: {
        id: null,
        total: 0,
        status: 'pending'
      },
      errors: []
    }
  },
  methods: {
    stepHandler(action, event) {
      if (action === 'next') {
        if (this.step < 2) {
          this.step++;
          this.cart.checkout = false
          trackVoucherEvent('Voucher Checkout Initiated', this.data.cineplex)
        } else {
          this.cart.checkout = true
          if (this.cart.contact.fullname && this.cart.contact.phone) {
            const modal = new BootstrapNative.Modal('#orderConfirmModal');
            modal.show()
          }
          event.preventDefault()
        }
      } else {
        if (this.step > 0) {
          this.step--;
        }
      }
    },
    getProduct() {
      axios.get('/voucher/' + this.cineplex + '/products')
          .then(r => {
            this.data.products = r.data.map((item) => {
              return {
                ...item,
                ...{ quantity: 0 }
              }
            })
          })
          .finally(() => {
            trackVoucherEvent('Voucher Product Loaded', this.data.cineplex)
          })
          .catch(e => {
            this.errors.push('Không tải được dữ liệu sản phẩm do có lỗi từ hệ thống đối tác')
            trackVoucherEvent('Voucher Product Load Failed', this.data.cineplex)
          });
    },
    getContact() {
      let contact = this.$root.getCookie().get('mvtix_customer');
      if (typeof contact !== "undefined") {
        this.cart.contact = JSON.parse(contact);
      }
    },
    getUser() {
      this.data.user = JSON.parse(this.user)
    },
    createOrder() {
      this.order.status = 'processing'
      let payload = {
        products: [],
        contact: this.cart.contact,
        paymentGateway: this.cart.paymentGateway,
        paymentMethod: this.cart.paymentMethod
      }

      // store contact to cookie
      this.$root.getCookie().set('mvtix_customer', { 'fullname' : this.cart.contact?.fullname, 'email' : this.cart.contact?.email, 'phone' : this.cart.contact?.phone }, { expires: 365 });

      this.cart.products.forEach(function (product) {
        if (product.quantity > 0) {
          payload.products.push({
            id: product.id,
            name: product.name,
            price: product.price,
            quantity: product.quantity,
          })
        }
      })

      axios.post('/voucher/' + this.cineplex + '/orders', payload)
          .then(r => {
            this.order.id = r.data.id
            this.order.status = r.data.status
            if (this.order.status === 'paid' || this.order.status === 'completed') {
              window.location = '/thong-tin-voucher/' + this.order.id
            } else {
              trackVoucherEvent('Voucher Order Created', this.data.cineplex, {
                order_id: this.order.id,
                order_status: this.order.status,
                order_amount: this.order.total,
                order_surcharge: 0
              }, true)
              window.location = '/thanh-toan-voucher/' + this.order.id
            }
          })
          .catch(e => {
            this.order.status = 'pending'
            if (e?.response?.status === 400) {
              this.errors.push('Không thể tạo đơn hàng do lỗi:' + JSON.stringify(e?.response?.data))
              trackVoucherEvent('Voucher Checkout Validation Failed ', this.data.cineplex)
            } else {
              this.errors.push('Không thể tạo đơn hàng do lỗi chưa xác định')
              trackVoucherEvent('Voucher Order Create Failed', this.data.cineplex)
            }
          });
    },
    productPicker(product, action, quantity = 1) {
      if (action === 'add') {
        product.quantity = product.quantity + quantity
      } else {
        product.quantity = product.quantity - quantity
      }

      let index = this.getPickedProductIndex(product)
      if (index === null && product.quantity > 0) {
        this.cart.products.push(product);
      }

      if (index !== null && product.quantity === 0) {
        this.cart.products.splice(index, 1);
      }
    },
    getPickedProductIndex(product) {
      let index = null
      this.cart.products.forEach(function (c, i) {
        if (c.id === product.id) {
          index = i
        }
      })

      return index
    },
    paymentMethodPicker(paymentGateway, paymentMethod = '') {
      if (paymentGateway === 'moveek' && paymentMethod === 'MOVEEK_CREDITS' && this.cart.creditPayable === false) {
        return
      }

      this.cart.paymentGateway = paymentGateway
      this.cart.paymentMethod = paymentMethod
    },
    calculateCartTotal() {
      let total = 0
      this.cart.products.forEach(function (product) {
        total += product.price * product.quantity
      })

      this.order.total = total
    },
  },
  watch: {
    cart: {
      handler: function () {
        this.calculateCartTotal()

        this.cart.creditPayable = this.data.user.balance >= this.order.total;
      },
      deep: true
    }
  }
}
</script>

<style scoped>
  label.required:after {
    content: " *";
  }
</style>